export const getRoles = (payload?: { isDeleted?: boolean, page?: number, perPage?: number }) => ({
    type: "@saga/GET_ROLES",
    payload
});